import { render, staticRenderFns } from "./exportTableDataComponent.vue?vue&type=template&id=081e5687&"
import script from "./exportTableDataComponent.vue?vue&type=script&lang=js&"
export * from "./exportTableDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports